/**
 * English - Error messages translations
 */
export const errors = {
  generic: 'Something went wrong. Please try again.',
  network: 'Network error. Please check your connection.',
  notFound: 'Page not found',
  unauthorized: 'You are not authorized to view this page.',
  forbidden: 'Access denied.',
  validation: 'Please correct the errors below.',
  sessionExpired: 'Your session has expired. Please log in again.',
  serverError: 'Server error. Please try again later.',
  loadFailed: 'Failed to load data. Please try again.',
  saveFailed: 'Failed to save. Please try again.',
  deleteFailed: 'Failed to delete. Please try again.',
  uploadFailed: 'Upload failed. Please try again.',
  maintenance: 'System under maintenance. Please try again later.',
  rateLimitExceeded: 'Too many attempts. Please try again later.',
  emailNotVerified: 'Please verify your email address before logging in.',
  accountLocked: 'Your account has been locked. Please contact support.',
  accountDeactivated: 'Your account has been deactivated. Please contact support.',
  calculator: {
    fetchFailed: 'Failed to load calculator data',
    loading: 'Loading calculator…',
    missingParams: 'Missing required parameters',
    noData: 'No data available',
  },
} as const;